import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { fetchHealthCheckupAppointments } from "../../Adapters/ApiAdapter";
import { toast, ToastContainer } from "react-toastify";

const ListAppointments = () => {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await fetchHealthCheckupAppointments();
        setAppointments(
          (response.data || []).sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          )
        );
      } catch (err) {
        toast.error("Failed to load appointments.");
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "full_name", headerName: "Full Name", width: 200 },
    { field: "phone", headerName: "Phone", width: 150 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "message", headerName: "Message", width: 300 },
    {
      field: "created_at",
      headerName: "Created At",
      width: 180,
      renderCell: (params) => new Date(params.value).toLocaleString("en-IN"),
    },
  ];

  return (
    <Box m="20px">
      <ToastContainer />
      <Typography variant="h4" gutterBottom>Appointments</Typography>
      {loading ? <CircularProgress /> : <DataGrid rows={appointments} columns={columns} autoHeight getRowId={(row) => row.id} />}
    </Box>
  );
};

export default ListAppointments;